import { io, type Socket } from 'socket.io-client';
import { loadConfig } from './config';

let socketPromise: Promise<Socket> | null = null;

/**
 * Lazy singleton socket.io client, wired to the sync server discovered
 * via /config.json. `rejectUnauthorized: false` is a no-op in the browser
 * but kept as a semantic marker in case we run in Node.
 */
export function getSocket(): Promise<Socket> {
  if (!socketPromise) {
    socketPromise = loadConfig().then((cfg) =>
      io(cfg.syncSocketURL, {
        transports: ['websocket', 'polling'],
        secure: true,
        // Send the session cookie on the handshake so the sync server's
        // io.use() middleware can identify the user for room ACL checks.
        withCredentials: true,
      }),
    );
  }
  return socketPromise;
}
